module.exports = __webpack_public_path__ + "static/media/obraz.b3913650.jpg";